import stripTags from "./strip-tags";

// try to get any description of event/moment
export default function getAnyDescription(event) {
  if (event) {
    if (event.moment && event.moment.short_description)
      return event.moment.short_description;
    if (event.moment && event.moment.description)
      return stripTags(event.moment.description);
    if (event.short_description) return event.short_description;
    if (event.description) return stripTags(event.description);
  }
  return "";
}
